"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterQuestionnaireSectionsByInsuranceModule = filterQuestionnaireSectionsByInsuranceModule;
const lodash_1 = __importDefault(require("lodash"));
function filterQuestionnaireSectionsByInsuranceModule(questionnaire, insuranceModules) {
    if (!insuranceModules.length) {
        return questionnaire;
    }
    return questionnaire.map((sectionGroup) => {
        const filteredSectionGroupSections = filterSectionsByInsuranceModules(sectionGroup.sections, insuranceModules);
        return { ...sectionGroup, sections: filteredSectionGroupSections };
    });
}
function filterSectionsByInsuranceModules(sections, insuranceModules) {
    return sections.filter((section) => {
        // include the sections without a filter
        if (!section.insuranceModuleFilter)
            return true;
        const matches = lodash_1.default.intersection(section.insuranceModuleFilter, insuranceModules);
        return !lodash_1.default.isEmpty(matches);
    });
}
